import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Select } from 'jl-design-system/components/select/Select';

import { triggerEditPageChangesMadeAnalytics } from '~/analytics/analytics.listener';

import styles from './ChosenPartnerDropdown.scss';
import { DEFAULT_PARTNER } from '~/routes/partners';

export class ChosenPartnerDropdown extends PureComponent {
  selectPartner = (event) => {
    const { value: partnerId } = event.target;
    const { selectPartner, partners, isEditMode } = this.props;
    const partner = partners.find((el) => el.id === partnerId) || DEFAULT_PARTNER;
    if (isEditMode) {
      triggerEditPageChangesMadeAnalytics('appointments', 'appointments:stylist');
    }
    selectPartner(partner);
  };

  render() {
    const { partner: selectedPartner, partners, partnerTitle, className, isSeries } = this.props;
    const partnersList = partners.map((partner) => ({
      label: partner.name ? partner.name : `All ${partnerTitle}s`,
      value: partner.id,
      id: partner.id,
    }));
    return (
      <div
        id="chosen-partner"
        className={classnames(styles.ChosenPartnerDropdown, className, {
          [styles.FluidDropDown]: isSeries,
        })}
        data-testid="ChosenPartnerDropdown"
      >
        <div className={styles.ChosenPartnerDropdown_line}>
          <p>Showing dates for</p>
          <Select
            id="chosenPartnerDropdown"
            value={selectedPartner.id ? selectedPartner.id : 'default'}
            name="chosenPartner"
            onChange={this.selectPartner}
            className={styles.ChosenPartnerDropdown_dropdown}
          >
            {partnersList.map((partner) => (
              <option key={partner.id} value={partner.value}>
                {partner.label}
              </option>
            ))}
          </Select>
        </div>
      </div>
    );
  }
}

ChosenPartnerDropdown.propTypes = {
  partner: PropTypes.shape({}),
  partners: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
  partnerTitle: PropTypes.string,
  selectPartner: PropTypes.func.isRequired,
  isEditMode: PropTypes.bool,
  className: PropTypes.string,
  isSeries: PropTypes.bool.isRequired,
};

ChosenPartnerDropdown.defaultProps = {
  partner: { id: null },
  partnerTitle: 'advisor',
  isEditMode: false,
  className: undefined,
};
